<template>
  <div>
    <h1 class="title">Oops!</h1>
    <p class="subtitle">No estás autorizado a ver esta información.</p>
  </div>
</template>

<script>
export default {
  name: "Forbidden"
};
</script>

<style scoped>
.title {
  font-size: 4rem;
  text-align: center;
  color: #678197;
  margin: 4rem 0 3rem;
}
.subtitle {
  text-align: center;
  font-size: 2rem;
  max-width: 800px;
  margin: 0 auto;
  color: #678197;
}
</style>
